import { useEffect, useState } from "react";
import NavigationTabs from "../../utils/components/NavigationTabs";
import DataTable from "../../utils/components/DataTable";
import Input from "../../utils/components/Input";
import { AiOutlineSearch } from "react-icons/ai";
import "./_formbox.scss";
import API from "../../utils/API";
import { useProject } from "../../utils/hooks/useProject";
import Loading from "../../utils/components/Loading";
import { Translate } from "react-localize-redux";
import Breadcrumbs from "../../utils/components/Breadcrumbs";
import { auth } from "../../App/routes";
import Modal from "../../utils/components/Modal";

const columns = {
  inbox: [
    {
      name: <Translate id="formbox.uppercase_translates.transaction-id" />,
      selector: (row) => row.transaction_id,
      maxWidth: "200px",
    },
    {
      name: <Translate id="formbox.uppercase_translates.sender" />,
      selector: (row) => row.sender.name,
      maxWidth: "200px",
    },
    {
      name: <Translate id="formbox.uppercase_translates.sender-company" />,
      selector: (row) => row.sender.company_name,
      maxWidth: "250px",
    },
    {
      name: <Translate id="formbox.uppercase_translates.receiver" />,
      minWidth: "200px",
      cell: (row) => (
        <div>{`${row.receiver[0].name}, ${row.receiver[0].company_name}`}</div>
      ),
    },
    {
      name: <Translate id="formbox.uppercase_translates.title" />,
      selector: (row) => row.form_name,
      cell: (row) => (
        <span>
          {row.form_name} - {row.form_no}
        </span>
      ),
    },
  ],

  sendbox: [
    {
      name: <Translate id="formbox.uppercase_translates.transaction-id" />,
      selector: (row) => row.transaction_id,
      maxWidth: "200px",
    },
    {
      name: <Translate id="formbox.uppercase_translates.sender" />,
      selector: (row) => row.sender.name,
      maxWidth: "200px",
    },
    {
      name: <Translate id="formbox.uppercase_translates.receiver" />,
      minWidth: "200px",
      selector: (row) => row.receiver[0].name,
    },
    {
      name: <Translate id="formbox.uppercase_translates.receiver-company" />,
      selector: (row) => row.receiver[0].company_name,
      maxWidth: "250px",
    },
    {
      name: <Translate id="formbox.uppercase_translates.title" />,
      selector: (row) => row.form_name,
      cell: (row) => (
        <span>
          {row.form_name} - {row.form_no}
        </span>
      ),
    },
  ],
};

const Formbox = ({ translate }) => {
  const formbox = {
    inbox: {
      label: translate("formbox.inbox"),
      value: "inbox",
    },
    sendbox: {
      label: translate("formbox.sendbox"),
      value: "sendbox",
    },
  };

  const [activeTab, setActiveTab] = useState(formbox.inbox.value);
  const [filteredData, setFilteredData] = useState([]);
  const [filterQuery, setFilterQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedFormBox, setSelectedFormBox] = useState(formbox.inbox.value);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [isPageLoading, setIsPageLoading] = useState(true);

  const [isProjectControl, setIsProjectControl] = useState(true);

  const { project } = useProject();

  const handleTabChange = (tab) => {
    if (tab === formbox.inbox.label) {
      setActiveTab(formbox.inbox.value);
      setSelectedFormBox(formbox.inbox.value);
      setPage(1);
    } else {
      setActiveTab(formbox.sendbox.value);
      setSelectedFormBox(formbox.sendbox.value);
      setPage(1);
    }
  };

  useEffect(() => {
    if (project?.id) {
      setIsPageLoading(true);
      const url = `formboxs/filters?project_id=${project?.id}&type=${activeTab}&search=${filterQuery}&page=${page}&size=${perPage}`;
      const payload = {
        companies: [],
        templates: [],
        who: "my",
        kind: "all",
      };

      API.postData(url, payload).then(({ data: res }) => {
        const { data, pagination } = res;

        setPage(pagination.current_page);
        setPerPage(pagination.page_size);
        setTotalRows(pagination.total_count);
        setFilteredData(data);
        setIsLoading(false);
        setIsPageLoading(false);
        setIsProjectControl(false);
      });
    } else {
      setIsPageLoading(false);
      setIsProjectControl(true);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, filterQuery, page, perPage]);

  return (
    <div className="formbox container-fluid">
      <div className="row">
        <div className="col-12 col-md-8">
          <Breadcrumbs
            data={[
              {
                id: 0,
                customTitle: translate(`page_titles.${auth.formBox.name}`),
                route: "auth.formBox",
              },
            ]}
          />
        </div>
        <div className="col-12 col-md-4">
          <Input
            type="text"
            placeholder={translate("formbox.placeholders.formbox-filter")}
            onChange={(e) => setFilterQuery(e.target.value)}
            iconNode={<AiOutlineSearch className="fs-5 me-2 mt-2" />}
          />
        </div>
      </div>
      <div className="row bg-white mt-4 pt-2">
        <div className="col-12">
          <NavigationTabs
            tabs={[formbox.inbox.label, formbox.sendbox.label]}
            activeTab={
              activeTab === formbox.inbox.value
                ? formbox.inbox.label
                : formbox.sendbox.label
            }
            onTabClick={(tab) => handleTabChange(tab)}
          />
        </div>
      </div>
      <div className="row bg-white">
        <div className="col-12">
          {isLoading ? (
            <Loading text={translate("loading")} />
          ) : (
            <DataTable
              columns={
                selectedFormBox === formbox.inbox.value
                  ? columns.inbox
                  : columns.sendbox
              }
              data={filteredData}
              onRowClicked={(row) =>
                window.open(
                  auth.formBoxDetails.link.replace(":id", row.task_id)
                )
              }
              highlightOnHover={true}
              pagination
              paginationServer
              paginationPerPage={perPage}
              onChangeRowsPerPage={(perPage) => {
                setPerPage(perPage);
              }}
              paginationTotalRows={totalRows}
              onChangePage={(page) => {
                setPage(page);
              }}
              progressComponent={<Loading text={translate("loading")} />}
              progressPending={isPageLoading}
            />
          )}
        </div>
      </div>
      <Modal
        title={translate("alert")}
        modaSize="lg"
        show={isProjectControl && !isPageLoading}
        setShow={setIsProjectControl}
      >
        <p className="fs-5 text-center mt-2">
          {translate("select_a_project_alert")}
        </p>
      </Modal>
    </div>
  );
};

export default Formbox;
